<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn color="primary" link to="/marketplace/grades/cadastro">
        <v-icon left>mdi-plus</v-icon>
        Grade
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma grade" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemGrade', ['stringFilter']),
    searchText: {
      get() {
        return this.$store.getters['listagemGrade/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemGrade/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
};
</script>
